import _throttle from 'lodash/throttle'
const BUTTON_THROTTLE_TIME = 500

export default {
  data() {
    return {
      registered: true, // 默认已注册，为控制点击下一步时触发blur&下一步校验，第一次校验被取消而通过校验的问题
    }
  },

  created() {},

  methods: {
    accountNext: _throttle(
      function () {
        this.$refs['form'].validate((valid) => {
          if (valid && !this.registered) {
            this.$store.commit('setCurrentAccount', this.form[this.type])
            this.$router.replace({
              path: '/cim/register/email/detail',
              query: {
                ...this.$route.query,
              },
            })
          }
        })
      },
      BUTTON_THROTTLE_TIME,
      { trailing: false }
    ),
  },
}
